import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '@/lib/api';

const LandingPageContentContext = createContext(null);

export const useLandingPageContent = () => {
  const context = useContext(LandingPageContentContext);
  if (!context) {
    throw new Error('useLandingPageContent must be used within LandingPageContentProvider');
  }
  return context;
};

export const LandingPageContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const data = await api.getLandingPage('landing_nextday');
        setContent(data);
      } catch (err) {
        console.error('Failed to fetch landing page content:', err);
      } finally {
        setLoading(false);
      }
    };
    
    fetchContent();
  }, []);

  const refreshContent = async () => {
    try {
      const data = await api.getLandingPage('landing_nextday');
      setContent(data);
    } catch (err) {
      console.error('Failed to refresh landing page content:', err);
    }
  };

  return (
    <LandingPageContentContext.Provider value={{ content, loading, refreshContent }}>
      {children}
    </LandingPageContentContext.Provider>
  );
};

export default LandingPageContentContext;
